import styled from 'styled-components';

import { useMatchMedia } from '@xing-com/crate-hooks-use-match-media';
import { NoSSR } from '@xing-com/crate-utils-no-ssr';
import { mediaWideNavless } from '@xing-com/layout-tokens';

import { useAdRefresh } from '../../hooks';

import { DisplayAdLogoutBillboard } from './billboard-ad';

const AdWrapper = styled.div`
  min-width: 728px;
  max-width: 970px;
  min-height: 90px;
  max-height: 250px;
  margin: 0 auto;
`;

export const DisplayAdBillboardSlot: React.FC = () => {
  const isWideSize = useMatchMedia(mediaWideNavless);

  const { refreshDesktop } = useAdRefresh({
    isSmallScreen: !isWideSize,
    slots: {
      mobile: '',
      desktop: 'billboard',
    },
  });

  if (!isWideSize) {
    return null;
  }

  return (
    <NoSSR>
      <AdWrapper>
        <DisplayAdLogoutBillboard refresh={refreshDesktop} />
      </AdWrapper>
    </NoSSR>
  );
};
